<template>
  <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify="emitKey" />
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import Validation from "@/services/recaptchaValidate";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      sitekey: "6LetHMEUAAAAAO1eNo-2jeNg30YP578e131XD2Po"
    };
  },
  methods: {
    emitKey(response) {
      this.$emit("keyRecaptcha", response);
    }
  }
};
</script>